<!--
 * @Date: 2019-06-05 12:02:48
 * @LastEditors: x
 * @LastEditTime: 2019-09-16 11:05:40
 -->
<!-- 吐司组件 -->
<template>
  <div class="toast">
    <transition name="toast">
      <div class="toast-content" v-if="isShowToast" v-html="msg"></div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "toast",
  data() {
    return {
      isShowToast: false,
      msg: ''
    };
  },

  components: {},

  computed: {},

  mounted() {
    this.$nextTick(() => {});
  },

  methods: {}
};
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/variable';
.toast-content {
  position: fixed;
  left:50%;
  bottom:25%;
  transform: translateX(-50%);
  background:rgba(0,0,0,.7);
  z-index:9999;
  padding:1rem 1.5rem;
  border-radius: 10px;
  text-align: center;
  color:#ffffff;
  font-size: 1.4rem;
}
.toast-enter-active{
    animation:in .3s;
}
.toast-leave-active{
    animation:out .3s;
}
@keyframes  in {
    0% {
        opacity:0;
    }
    100% {
        opacity:1;
    }
}
@keyframes  out {
    0% {
        opacity:1;
    }
    100% {
        opacity:0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/base/toast/toast.vue